<template lang="html">
  <div class="product">
    <div class="productDetails" v-if="personProductList.length > 0">
      <div v-for="a in personProductList" :key="a.id" class="content" @click="goProduct(a.id)">
        <img :src="a.product_cover" alt="" class="productCover">
        <div class="productTitle"><span v-show="a.recommended_index > 0">置顶</span>{{a.product_name}}</div>
        <div class="productInfo">
          <p class="productPrice" v-if="a.reference_price"><span>￥</span>{{a.reference_price}}<span>参考价</span></p>
          <p class="productPrice" v-else><span>暂无参考价</span></p>
          <p class="productView">
            <img src="@/assets/image/icon/browse.png" alt="">
            <span>{{a.view_number}}</span>
          </p>
        </div>
      </div>
    </div>
    
    <div v-else class="noInfo">
      <div>
        <img :src="`${pagebase}/static/img/elecom/product.png`" alt="">
      </div>
      <p>还没有发布任何产品内容哦</p>
    </div>
  </div>
</template>

<script>
  import {apppagebase, pagebase} from '@/utils/http'

  export default {
    props: ['userId'],

    data() {
      return {
        personProductList: [],
        pagebase: pagebase,
        apppagebase: apppagebase,
      }
    },

    mounted() {
      this.init();
    },

    methods: {
      init() {
        this.getPersonProductList();
      },

      getPersonProductList() {
        this.$http({
          url: '/product/personProductList',
          method: 'get',
          params: {
            master_id: this.userId,
            page: 1,
          }
        }).then(res => {
          if (res.code >= 0) {
            this.personProductList = res.data;
          }
        })
      },
      
      goProduct(pid){
        sessionStorage.setItem('cur', 3);
        this.$router.push({
          path: '/product',
          query: {
            pid: pid,
          }
        })
      },
    },
  }
</script>

<style lang="css" scoped>
  .productDetails {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 1.5rem;
  }

  .content {
    position: relative;
    box-sizing: border-box;
    width: 48%;
    margin-bottom: 2rem;
  }

  .productCover {
    width: 100%;
    height: 16.7rem;
    object-fit: cover;
    border-radius: .5rem;
  }

  .productTitle {
    font-size: 1.4rem;
    height: 3.8rem;
    color: #1D2023;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .productTitle span {
    box-sizing: border-box;
    border-radius: .3rem;
    padding: 0 .3rem;
    font-size: 1rem;
    color: #FFFFFF;
    background: linear-gradient(to right, #FF6F6F, #F82945);
    margin-right: .5rem;
  }

  .productInfo {
    display: flex;
    justify-content: space-between;
  }
  
  .productView{
    display: flex;
    align-items: center;
    font-size: 1rem;
    color: #C0C4CC;
  }
  
  .productView img{
    width: 1.4rem;
    height: 1.4rem;
    margin-right: .5rem;
    border-radius: .5rem;
    object-fit: cover;
  }

  .productPrice {
    font-size: 1.8rem;
    color: #F7443F;
  }

  .productPrice span {
    font-size: 1rem;
  }
  
  .noInfo {
    height: 37.5rem;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
  
  .noInfo img {
    width: 19.5rem;
    height: 19.5rem;
  }
  
  .noInfo p {
    font-size: 1.4rem;
    color: #9CA3A9;
  }
</style>
